import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textInput", "dropdown"]

  connect() {
    this.hideDropdown()
  }

  showDropdown() {
    this.dropdownTarget.classList.remove("hidden")
  }

  hideDropdown() {
    setTimeout(() => {
      this.dropdownTarget.classList.add("hidden")
    }, 200) // Delay to allow click events on dropdown items
  }

  selectRecommendation(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.value
    this.textInputTarget.value = value
    this.hideDropdown()
  }
}